import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_ryDe4ZWpv8R0: {
	id: 'prd_ryDe42DEV2ZWpv8R0'
	ident: 'prd_ryDe4ZWpv8R0'
	sku: 'simple_premium_6m_27_19_6m_139_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 6
			iteration_count: 1
			price_id: 'prc_EZ46k2DEV2Fy59wHK'
			amount: 139
			amount_usd: 27.19
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 27.19
			discount: 111.81
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 6
			iteration_count: null
			price_id: 'prc_LRrK42DEV2eWrCLYM'
			amount: 139
			amount_usd: 139
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_ryDe4ZWpv8R0, SubscriptionProduct>
const prd_ryDe4ZWpv8R0 = { ident: 'prd_ryDe4ZWpv8R0' } as typeof _prd_ryDe4ZWpv8R0

export default prd_ryDe4ZWpv8R0
